import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SlideMenu.css';
class SlideMenu extends Component {
  static propTypes = {
    menuItems: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired
  };
  render() {
    return <div className="slide-menu-scrolling-wrapper">{this.displayMenu(this.props.menuItems)}</div>;
  }

  displayMenu = menuItems => {
    return menuItems.map(item => (
      <div key={item.id} className="slide-menu-menu-item" onClick={() => this.props.onClick(item.id)}>
        {item.label}
      </div>
    ));
  };
}

export default SlideMenu;



// WEBPACK FOOTER //
// ./src/Components/SlideMenu/SlideMenu.js